import { checkString } from "../../components/Nip-Integration/Outward/OutwardTest/Functions";

function FTFixedValues(
  nameEnquiryData,
  XmlCovert,
  newTimeStamp,
  random_number
) {
  const enquiryData = nameEnquiryData && XmlCovert(nameEnquiryData);
  const parsedData = enquiryData && JSON.parse(enquiryData);
  const fixedData = parsedData && parsedData.NESingleResponse;
  const channelCode =
    fixedData && fixedData.ChannelCode && fixedData.ChannelCode._text;
  const destinationCode =
    fixedData &&
    fixedData.DestinationInstitutionCode &&
    fixedData.DestinationInstitutionCode._text;
  return {
    time_stamp: newTimeStamp,
    random_number: random_number,
    channel_code: channelCode,
    destination_code: destinationCode,
    nameEnquiryRef:
      fixedData && fixedData.SessionID && fixedData.SessionID._text,
    beneficiaryAccountName:
      fixedData &&
      fixedData.AccountName &&
      fixedData.AccountName._text &&
      checkString(fixedData.AccountName._text),
    beneficiaryAccountNumber:
      fixedData && fixedData.AccountNumber && fixedData.AccountNumber._text,
    beneficiaryBankVerificationNumber:
      fixedData &&
      fixedData.BankVerificationNumber &&
      fixedData.BankVerificationNumber._text,
    beneficiaryKYCLevel:
      fixedData && fixedData.KYCLevel && fixedData.KYCLevel._text,
  };
}

export default FTFixedValues;
